import { JsonObject, JsonProperty, JsonDelayedProperty } from 'projects/core/src/public-api';
import { TrelloObject } from './trello-object';
import { TrelloCard } from './trello-card';
import { TrelloCheckItem } from './trello-check-item';

@JsonObject('model.trello.TrelloChecklist')
export class TrelloChecklist extends TrelloObject {

    @JsonDelayedProperty('TrelloChecklist', 'TrelloCard', 'card')
    card?: TrelloCard;

    @JsonDelayedProperty('TrelloChecklist', '[TrelloCheckItem]', 'checkItems')
    // @JsonProperty([TrelloCheckItem], 'checkItems')
    checkItems?: TrelloCheckItem[];
}